import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { DemandasMonitoramento } from '../../models/demandas-monitoramento.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { DemandasMonitoramentoService } from '../../services/demandas-monitoramento.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-demanda-monitoramento-list',
  templateUrl: './detalhe-projeto-demanda-monitoramento-list.component.html',
  styleUrls: ['./detalhe-projeto-demanda-monitoramento-list.component.scss']
})
export class DetalheProjetoDemandaMonitoramentoListComponent extends BaseListComponent<DemandasMonitoramento> implements OnInit, OnDestroy {

  @Input() idEntrega: number;
  @Input() idIndicador: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  canDemand: boolean = false;
  canceladas: boolean = false;
  demandasList: DemandasMonitoramento[];

  constructor(
    private myService: DemandasMonitoramentoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.canceladas = false;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idEntrega) {
      this.addSub(
        this.myService.entregaList(this.idEntrega).subscribe((res) => {
          this.demandasList = res['demandas'];
          this.canDemand = res['canDemand'];
          this.loaded();
        })
      );
    } else if (this.idIndicador) {
      this.addSub(
        this.myService.indicadorList(this.idIndicador).subscribe((res) => {
          this.demandasList = res['demandas'];
          this.canDemand = res['canDemand'];
          this.loaded();
        })
      );
    }
  }

  viewDemanda(id) {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', id, 'mensagens'];
  }

  novaDemandaLink(){
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar']
  }

  novaDemandaParams() {
    if (this.idEntrega) {
      return { pf_prt_issue_id: this.idEntrega };
    }
    else if (this.idIndicador) {
      return { pf_indicator_id: this.idIndicador };
    }
  }

  mostrarCanceladas() {
    this.canceladas = !this.canceladas;
  }
}
